<template>
      <div no-body class="lku-adv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-input-group v-else>
          <b-input-group-prepend><span class="pt-1 mr-1">Filter</span></b-input-group-prepend>
          <b-form-input v-model="tblData.requestno" @keyup.13.native="refresh()" size="sm" placeholder="Request No."></b-form-input>
          <b-form-input v-model="tblData.requestby" @keyup.13.native="refresh()" size="sm" class="ml-1" placeholder="Request By"></b-form-input>
          <b-form-input v-model="tblData.inspectName" @keyup.13.native="refresh()" size="sm" class="ml-1" placeholder="Description" style="width:30% !important"></b-form-input>
          <b-form-input v-model="tblData.category" size="sm" class="ml-1" placeholder="Asset Category" @keyup.13.native="refresh()" style="width:15% !important"></b-form-input>                                       
          <b-input-group-append>
            <b-button size="sm" class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear</b-button>
          </b-input-group-append>
      </b-input-group>
        <b-table
          class="mb-0"
          ref="tblPr"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
          show-empty
        >
          <template v-slot:cell(requestdate)="data">
            {{ data.item.requestdate | moment("DD MMM YYYY") }}
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      </div>
</template>
<style lang="scss">
  .lku-adv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import requisition from "../../apis/maintenrequest";
export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "requestby",
            label: "Request By",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "inspectName",
            label: "Description",
            sortable: true
          },
          {
            key: "asetid",
            label: "Fixed Asset#",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "asetdesc",
            label: "Fixed Asset Name",
            sortable: true
          },
          {
            key: "ascateg",
            label: "Fixed Asset Catagory",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'requestdate',
        sortDesc: false,
        status:'0'
      },
      lkuLoading:false
    };
  },
  props:['filter'],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if(this.filter){
        for (const key in this.filter) {
          if (this.filter.hasOwnProperty(key)) {
            this.tblData[key] = this.filter[key]; 
          }
        }
      }
      // console.log('this.tblData',this.tblData)
      this.lkuLoading=true;
      const list = await requisition.list(this.tblData);          
      this.lkuLoading=false;
      return list;
    },

    selectItem(item,index) {
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.inspectName=  '';
        this.tblData.requestno=  '';
        this.tblData.requestby=  '';
        this.tblData.category=  '';
        this.refresh();
    },    
    refresh: async function() {
      this.$refs.tblPr.refresh();
    }
  }
};
</script>
